import React from 'react'

const Reverse_list = () => {
    return (
        <div className='container'>
            <h1>Reversing a List </h1>
            <p>In this method, we neither reverse a list in-place(modify the original
                 list), nor we create any copy of the list. Instead, we get a reverse 
                 iterator which we use to cycle through the list.</p>
            <div className='containers'>
            # You have this:  <br />
[1, 2, 3, 4, 5]<br /><br />

# And you want that:<br />
[5, 4, 3, 2, 1]<br />
            </div>
            <div className='containers'>
           <code className='comment'> # Reversing a list using reversed()</code> <br />
          <code className='keywords'>def Reverse </code>(lst): <br />
          &nbsp;  <code className='library'>return </code>[ele for ele in reversed(lst)] <br />
      <br /> <br />

      <code className='keywords'>lst </code>= [10, 11, 12, 13, 14, 15] <br />
      <code className='keywords'>print</code>(Reverse(lst)) <br />
            </div>
            <div className='output'>
            [15, 14, 13, 12, 11, 10]
            </div>
        </div>
    )
}

export default Reverse_list
